import Service, { service } from "@ember/service";

export default class CostService extends Service {
  @service current;

  get currency() {
    return this.current.project.currency;
  }

  get prices() {
    return {
      loadBalancer: { SEK: 248, EUR: 24.77 },
      vpn: { SEK: 61.9, EUR: 6.19 },
      archive: { SEK: 1.23, EUR: 0.11 },
      remoteHands: {
        officeHours: { SEK: 1109, EUR: 110.85 },
        nonOfficeHours: { SEK: 1970, EUR: 196.94 },
      },
      network: { SEK: 310, EUR: 30.95 },
      email: {
        account: { SEK: 11.25, EUR: 1.12 },
        storage: { SEK: 3.38, EUR: 0.34 },
      },
      backup: {
        storage: { SEK: 0.37, EUR: 0.03 },
      },
      ipv4: { SEK: 28.13, EUR: 2.82 },
      ipv6: { SEK: 1.12, EUR: 0.1 },
    };
  }

  forManualBackup(size) {
    return this.formatCost(size * this.prices.backup.storage[this.currency]);
  }

  forNetworkAdapter(bandwidth, server, network) {
    let platformArguments = server?.get("platformArguments");

    let bandwidthOptions = platformArguments?.get("externalBandwidthOptions");

    if (network && !network.get("isPublic")) {
      bandwidthOptions = platformArguments?.get("internalBandwidthOptions");
    }

    let bandwidthOption = bandwidthOptions?.find((option) => option.value === bandwidth);

    return bandwidthOption ? bandwidthOption.basecost + bandwidthOption.licensecost : 0;
  }

  forEmailAccount(quota = 1) {
    return this.formatCost(
      (Math.ceil(quota) - 1) * this.prices.email.storage[this.currency] + this.prices.email.account[this.currency],
    );
  }

  forNetwork() {
    return this.formatCost(this.prices.network[this.currency]);
  }

  forRemoteHands() {
    return {
      officeHours: this.formatCost(this.prices.remoteHands.officeHours[this.currency]),
      nonOfficeHours: this.formatCost(this.prices.remoteHands.nonOfficeHours[this.currency]),
    };
  }

  forArchive(size) {
    return this.formatCost(size * this.prices.archive[this.currency]);
  }

  forVpnUser() {
    return this.formatCost(this.prices.vpn[this.currency]);
  }

  forLoadBalancer() {
    return this.formatCost(this.prices.loadBalancer[this.currency]);
  }

  forIpVersion(version) {
    return this.formatCost(this.prices[`ipv${version}`][this.currency]);
  }

  formatCost(cost) {
    return {
      cost: cost ? Number(cost.toFixed(2)) : "N/A",
      currency: this.currency ?? "",
    };
  }
}
